import React, { useContext } from 'react';
import { Card, Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';
import '../../../../assets/textDirection.css';

const { TextArea } = Input;

const Language = ({ reportData, form, langCode, language, defaultLang }) => {
  const { getFieldDecorator } = form;
  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    <>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Card bordered={false}>
                <Form.Item label="About">
                  {getFieldDecorator('description-' + langCode, {
                    rules: defaultLang
                      ? [
                          {
                            required: true,
                            message: 'About is required.',
                          },
                        ]
                      : [],
                    initialValue: reportData
                      ? reportData.description
                      : undefined,
                  })(
                    <TextArea
                      disabled={disable}
                      rows={10}
                      showCount
                      maxLength={2000}
                      className={
                        language.directionRightToLeft ? 'rightToLeftText' : ''
                      }
                    />,
                  )}
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
Language.propTypes = {
  form: PropTypes.object,
  reportData: PropTypes.object,
  langCode: PropTypes.string,
  language: PropTypes.object,
  defaultLang: PropTypes.string,
};

Language.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(Language);
